import styled from "styled-components";

export const ShowcaseDisplayContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    position: relative;
    width: 100%;
`

export const MainTitleContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
    width: 100%;
`

export const HeaderActions = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    z-index: 1;
`

export const ViewToggle = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 999px;
    display: flex;
    padding: 3px;
`

export const ViewToggleButton = styled.button`
    background: ${({ $active }) => $active ? 'rgba(255, 255, 255, 0.18)' : 'transparent'};
    border: none;
    border-radius: 999px;
    color: #ffffff;
    cursor: pointer;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 13px;
    letter-spacing: 0.08em;
    opacity: ${({ $active }) => $active ? 1 : 0.6};
    padding: 6px 12px;
    text-transform: uppercase;

    &:hover {
        opacity: 1;
    }
`

export const ContentContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: ${({ $view }) => $view === 'carousel' ? 'column' : 'row'};
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`